import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { BookOpen } from "lucide-react";

export default function HowTo() {
  const { key } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/howto").then((r) => setData(r.data)).catch(() => setData({})); }, []);
  if (!data) return <div className="p-8 text-sm text-slate-400">Loading…</div>;
  const items = data.howtos || {};
  const h = key ? items[key] : null;
  return (
    <div className="max-w-[1100px] w-full mx-auto px-6 sm:px-8 py-8" data-testid="howto-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 flex items-center gap-2"><BookOpen className="w-5 h-5 text-[#003E87]" /> How to</h1>
      <p className="text-sm text-slate-500 mt-0.5">One screen per feature: what it is, what to do, what happens next. Claude reads the same words.</p>
      <div className="flex flex-wrap gap-2 mt-4" data-testid="howto-nav">
        {Object.entries(items).map(([k, v]) => <Link key={k} to={`/how-to/${k}`} data-testid={`howto-link-${k}`} className={`text-xs px-2.5 py-1 rounded-full border whitespace-nowrap ${k === key ? "bg-[#003E87] text-white border-[#003E87]" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{v.title}</Link>)}
      </div>
      {h && (
        <div className="bg-white border border-slate-200 rounded-xl p-6 mt-5" data-testid={`howto-${key}`}>
          <h2 className="text-lg font-semibold text-slate-900">{h.title}</h2>
          <p className="text-sm text-slate-700 mt-2">{h.what}</p>
          <ol className="mt-4 grid md:grid-cols-2 gap-3">
            {h.steps.map((s, i) => <li key={i} className="rounded-lg bg-slate-50 p-3 text-sm text-slate-700"><span className="text-[11px] text-slate-400 block">Step {i + 1}</span>{s}</li>)}
          </ol>
          <p className="text-sm text-slate-600 mt-4"><b>What happens next:</b> {h.next}</p>
        </div>
      )}
      {!h && <p className="text-sm text-slate-500 mt-5">Pick a feature above.</p>}
    </div>
  );
}
